import React from 'react';
import styles from './FormLabel.module.css';

const FormLabel = ({ children, error }) => <span className={error ? styles.errorLabel : styles.label}>{children}</span>;

export default FormLabel;
